export const mirrorReplace = (text: string, pgmId: string, ecData: any): string => {
  if (!text || pgmId !== "FMAT_MIRROR" || !ecData?.ecodeByPaper) return text
  if (ecData.ecodeByPaper.isLeader) return text
  const name = ecData.ecodeByPaper.leaderName
  if (!name) return text
  return text
    .replace(/'나'/g, `'${name}님'`)
    .replace(/자신과/g, `${name}님과`)
    .replace(/자신을/g, `${name}님을`)
    .replace(/자신의/g, `${name}님의`)
    .replace(/자신/g, `${name}님`)
    .replace(/나는/g, `${name}님은`)
    .replace(/나와/g, `${name}님과`)
    .replace(/나의/g, `${name}님의`)
    .replace(/나에게/g, `${name}님에게`)
    .replace(/나를/g, `${name}님을`)
    .replace(/(?<!님에게 )학습 환경은/g, `${name}님에게 학습 환경은`)
}
